export interface CalendarAuditTooltipDetails {
  startDate: string;
  endDate: string;
  service: string;
  auditType: string;
  siteAddress: string;
  acceptedDate: string;
  status: string;
}
